module.exports = __webpack_public_path__ + "img/zhonglian_logo.8c8187f7.png";